import { IsNumber } from 'class-validator';
import { GiftCardRefundBaseRequestDto } from './gift-card-refund-base-request.dto';

export class GiftCardPhysicalRefundRequestDto extends GiftCardRefundBaseRequestDto {
  @IsNumber()
  physicalGiftCardId: number;

  constructor(from?: {
    physicalGiftCardId: number;
    refundReasonId: number;
    commentReason: string;
  }) {
    super();

    if (!from) {
      return;
    }
    this.physicalGiftCardId = from.physicalGiftCardId;
    this.refundReasonId = from.refundReasonId;
    this.commentReason = from.commentReason;
  }
}
